var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagAfghanistan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_14820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9565 1.58763C20.853 0.5705 18.4931 0 16 0C13.5069 0 11.147 0.5705 9.0435 1.58763L7.65219 16L9.0435 30.4124C11.147 31.4295 13.5069 32 16 32C18.4931 32 20.853 31.4295 22.9565 30.4124L24.3478 16L22.9565 1.58763Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.0435 1.58813C3.69163 4.17607 0 9.65664 0 15.9999C0 22.3433 3.69163 27.8238 9.0435 30.4118V1.58813Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9561 1.58813V30.4118C28.3079 27.8238 31.9996 22.3433 31.9996 15.9999C31.9996 9.65664 28.3079 4.17607 22.9561 1.58813Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 10.4348C12.9264 10.4348 10.4348 12.9264 10.4348 16C10.4348 19.0736 12.9264 21.5652 16 21.5652C19.0736 21.5652 21.5652 19.0736 21.5652 16C21.5652 12.9264 19.0736 10.4348 16 10.4348ZM16 19.4783C14.079 19.4783 12.5218 17.9209 12.5218 16C12.5218 14.0791 14.0791 12.5218 16 12.5218C17.9209 12.5218 19.4783 14.0791 19.4783 16C19.4783 17.9209 17.921 19.4783 16 19.4783Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 13.9131C15.2316 13.9131 14.6087 14.536 14.6087 15.3044V17.3913H17.3913V15.3044C17.3913 14.536 16.7685 13.9131 16 13.9131Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_14820"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagAfghanistan);
export default __webpack_public_path__ + "static/media/flag_afghanistan.3ec80313de81f4b47d5fcf251fd900bb.svg";
export { ForwardRef as ReactComponent };